import api from '..'

const requests = {
    fetchProducts: async ({ search, sortKey, sortType, pageSize, pageNo }) => {
        try {
            var response = await api.get(`/wellful/Product/`, {
                params: {
                    search,
                    sortKey,
                    sortType,
                    pageSize,
                    pageNo
                }
            })

            return response.data
        } catch (error) {
            throw error.response ? error.response.status : error
        }
    },
    fetchProduct: async (id) => {
        try {
            var response = await api.get(`/wellful/Product/${id}`)
            return response.data
        } catch (error) {
            throw error.response ? error.response.status : error
        }
    },
    createProduct: async (payload) => {
        try {
            var response = await api.post(`/wellful/Product`, payload)
            return response.data
        } catch (error) {
            throw error.response ? error.response.status : error
        }
    },
    updateProduct: async (payload) => {
        try {
            var response = await api.put(`/wellful/Product/${payload.id}`, payload)
            return response.data
        } catch (error) {
            throw error.response ? error.response.status : error
        }
    },
    fetchProductSummary: async (search) => {
        // try {
        //     var response = await api.get(`/data/getCRMcontactsSummary.php`, {
        //         params: {
        //             custID,
        //             bdm,
        //             search
        //         }
        //     })
        //     return response.data
        // } catch (error) {
        //     throw error.response ? error.response.status : error
        // }
        return null
    }
}

export default requests
